import { createSnapshotService } from "@/shared/projects/snapshot.service";

export const faqSnapshotService = createSnapshotService("faq", "faq");
